// extracted by mini-css-extract-plugin
module.exports = {"CircleLoader":"index-module--CircleLoader--3mX-x","loaderSpin":"index-module--loaderSpin--L91r0","Small":"index-module--Small--1xUz0"};